const isIE = navigator.userAgent.indexOf('MSIE') !== -1 || !!document.documentMode;
let PDFJSLib = { };

if (!isIE) {
    PDFJSLib = require("qys-pdfjs/build/pdf.js");
    const PDFJsWorker = require("worker-loader?esModule=false&filename=js/[hash].worker.js!qys-pdfjs/build/pdf.worker.js");
    if (typeof window !== "undefined" && "Worker" in window) {
        PDFJSLib.GlobalWorkerOptions.workerPort = new PDFJsWorker();
    }
}

export default PDFJSLib;